import { ReactNode } from 'react'

import { Box, Tag, TagColor } from '@factorialco/deprecated-design-system'

export const SectionWithStatus: React.FC<{
  tagColor: TagColor
  tagLabel: string
  count?: number
  children: ReactNode
}> = ({ tagColor, tagLabel, count, children }) => {
  return (
    <Box gap="s16">
      <Tag type={tagColor} inline>
        {tagLabel}
        {count !== undefined && <> ({count})</>}
      </Tag>
      <Box>{children}</Box>
    </Box>
  )
}
